export default {
  report: 'Report',
  build: 'Build',
  buildAndReport: 'Build and report',
  mixed: 'Several ngtorch versions',
  kindBranch: 'branch',
  kindCommit: 'commit',
  plans: '{count} plan | {count} plans',
  reinstall: 'With package metadata reinstall',
  frozenAt: 'Resolved on {date}',
  withoutOverride: '{count} plan on the image ngtorch | {count} plans on the image ngtorch'
}
